<button [matTooltipPosition]="position" [matTooltip]="withText?'':tooltip" [matTooltipDisabled]="disabled"
  mat-icon-button
  [color]="color"
  [disabled]="disabled" (click)="onClick()" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <mat-icon>{{ currentIcon }}</mat-icon>
  @if (withText) {
    <span class="icon-text">{{ tooltip }}</span>
  }
</button>
